export default "__VITE_ASSET__D6y7iIps__"